'use client';
import Link from 'next/link';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const NotFound = () => {
    return (
        <div className='flex flex-col items-center justify-center grow h-[95%]'>
            <div className="mb-10">
                <img
                    src={('/assets/media/illustrations/19.svg')}
                    className="dark:hidden max-h-[160px]"
                    alt="image"
                />
                <img
                    src={('/assets/media/illustrations/19-dark.svg')}
                    className="light:hidden max-h-[160px]"
                    alt="image"
                />
            </div>

            <span className="badge badge-primary badge-outline mb-3"><FormattedMessage id="ERROR_404_TITLE" /></span>

            <h3 className="text-2.5xl font-semibold text-gray-900 text-center mb-2">
                <FormattedMessage id="ERROR_404_SUBTITLE" />
            </h3>

            <div className="text-md text-center text-gray-700 mb-10">
                <FormattedMessage id="ERROR_404_DESCRIPTION" />&nbsp;
                <Link href="/" className="text-primary font-medium hover:text-primary-active">
                    <FormattedMessage id="ERROR_404_RETURN_HOME" />
                </Link>
                .
            </div>
        </div>
    );
};

export default NotFound;